import { render, staticRenderFns } from "./TestBankQuestionEditor.vue?vue&type=template&id=f884e70c&scoped=true"
import script from "./TestBankQuestionEditor.vue?vue&type=script&lang=js"
export * from "./TestBankQuestionEditor.vue?vue&type=script&lang=js"
import style0 from "./TestBankQuestionEditor.vue?vue&type=style&index=0&id=f884e70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f884e70c",
  null
  
)

export default component.exports